/* globals GLOBALS, mobile */
/*
This serves as a way to bind events throughout different pages and creates
such bindings on load.
*/

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone_fetch_cache';

import FastClick from 'fastclick';


FastClick.attach(document.body);

// Overwrite Urls functions with extra logic to create native links when
// desired. Relies on a naming convention of [branding]-[uri_slug].html
// where uri_slug is the uri with leading/trailing '/'s removed and other
// '/'s replaced with '-'s
var webappUrls = _.clone(window.Urls);
_.each(webappUrls, function (func, name) {
  window.Urls[name] = function (args, options) {
    args = args || {};
    options = options || {};
    var webappUrl = webappUrls[name](args);
    if (!mobile || !options.native) {
      return webappUrl;
    }
    var nativeUrl = webappUrl.slice(1, -1).replace(/\//g, '-') + '.html';
    if (GLOBALS.BRANDING === 'default') {
      return nativeUrl;
    }
    return GLOBALS.BRANDING + '-' + nativeUrl;
  };
});

$('a#logout_link, a#mobile_logout_link').click(function () {
  if ($('html.localstorage').length) {
    window.localStorage.removeItem(Backbone.fetchCache.getLocalStorageKey());
  }
});

// Override backbone's PATCH method to work with tastypie
var oldSync = Backbone.sync;
Backbone.sync = function (method, model, options) {
  if (method === 'patch') {
    options.attrs = { objects: model.toJSON(options) };
  }
  return oldSync(method, model, options);
};



// WEBPACK FOOTER //
// ./static/js/utils/global_events.js